import Router from 'vue-router';
import router from './router';
import routerRefi from './routerRefi';
import routerBlocks from './routerBlocks';
import routerMeuFinanciamento from './routerMeuFinanciamento';
import {RefiDigitalEnum} from "@/helpers/refi-digital.enum";
import routerMeuFinanciamentoArisco from '@/routerMeuFinanciamentoArisco';


export class Client {
    static myMap = new Map<string | null, Router>([
        [null, router],
        [RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT, routerRefi],
        [RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT_BEBLUE, routerRefi],
        [RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT_PAGBEM, routerRefi],
        [RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT_PORTOCRED, routerRefi],
        ["blocks", routerBlocks],
        ['meu-financiamento',  routerMeuFinanciamento],
        ['meu-financiamento-arisco',  routerMeuFinanciamentoArisco],
    ]);

    public static getRouter(clientId: string | null) : Router{
        const vueRouter = this.myMap.get(clientId);
        return vueRouter ? vueRouter : router;
    }
}